exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kng-expand-collapse .collapsable {\n  margin-left: 0;\n  overflow: visible;\n}\n.kng-expand-collapse .collapsable .hidden {\n  display: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-expand-collapse/kng-expand-collapse.component.less
// module id = ../../../../../src/app/layout/kingswell/kng-expand-collapse/kng-expand-collapse.component.less
// module chunks = main